import { DECommonTable } from 'components/DataExpansionComponents/Common/CommonTable/CommonTable'
import { DataTableProvider } from 'components/DataTable'
import { ContactResponse } from 'models/contacts'
import apiService from 'services/api'
import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { dataTableSortingStoreRepo } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { IColumnVisibility } from '../../../../DataTable/types'
import { useConvenienceDoorsTableCols } from './ConvenienceDoorsTableColumns'
import { FilterIdentifier } from 'models/saved_view'
import { ConvenienceDoorsFilterset } from './ConvenienceDoorsFilterset'
import { StandardSummaryResponse } from 'models/paginated-response'
import ConvenienceDoorExportModal from 'components/Modals/ExportModal/ConvenienceDoorExportModal'

type SortableFields = (keyof ContactResponse | string)[]

const sortableFields: SortableFields = [
  'note_count',
  'contact_count',
  'deal_count',
  'name',
  'address',
  'city',
  'state',
  'country',
  'phone',
  'website',
  'reviews_avg',
  'reviews_cnt',
  'chain_doors_cnt',
]

export interface ConvenienceTableProps {
  setTotalRowsCount?: (count: StandardSummaryResponse) => void
  pageParamName?: string
  baseFilters?: Record<string, any>
  tableKey: string
  filterIdentifierModifier?: FilterIdentifier
  hideCreateCompanyButton?: boolean
  AfterSearchComponent?: React.ReactNode
}

function ConvenienceDoorTableComponent(props: ConvenienceTableProps) {
  const api = apiService()
  const { tableKey, ...rest } = props
  const { sorting } = dataTableSortingStoreRepo.getStore(props.tableKey)()
  const columns = useConvenienceDoorsTableCols({
    sorting,
    inCampaigns: props.baseFilters?.campaigns,
  })
  return (
    <DECommonTable
      {...rest}
      tableKey={tableKey}
      columns={columns}
      sortableFields={sortableFields}
      filterIdentifier="CONVENIENCE_DOOR_TABLE"
      apiGetListAction={api.getConvenienceDoorList}
      apiGetSummaryAction={api.getConvenienceDoorSummary}
      companyTypeSlug="convenience"
      tableTypeSlug="convenience-doors"
      searchPlaceholder="Search convenience stores by name"
      FilterSet={ConvenienceDoorsFilterset}
      ExportModal={ConvenienceDoorExportModal}
      acessorKey="chain_proxy.id"
    />
  )
}

export function ConvenienceDoorTable(
  props: ConvenienceTableProps & {
    defaultColumnVisibility?: IColumnVisibility<any>
  }
) {
  const { tableKey, defaultColumnVisibility, ...rest } = props

  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
      savedPresetsIdentifier="CONVENIENCE_DOOR_TABLE"
      preferredGroupOrder={['Opportunity Attributes', 'Campaigns and Deals']}
    >
      <DataTableProvider tableKey={tableKey}>
        <ConvenienceDoorTableComponent tableKey={tableKey} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
